import {Drawer} from './Drawer';
import {cloneTemplate} from '../Library/WebComponents';
import {isMobile} from '../Library/Viewport';

/**
 * @param {{title: string, content: string|HTMLElement, footer: ?(string|HTMLElement),
 *   cancelLabel: ?string, onClose: function}} options
 */
export const Modal = (options) => {
    const {title, content, footer = null, cancelLabel = null, onClose = () => {}, onConfirm} = options;

    const fragment = cloneTemplate('#modal-dialog-template');
    const dialog = fragment.querySelector('.modal-dialog');
    const cancel = dialog.querySelector('.cancel');

    dialog.querySelector('h2').textContent = title;
    dialog.querySelector('.content').appendChild(content);

    if (footer !== null) {
        dialog.querySelector('footer').appendChild(footer);
    }

    if (cancelLabel !== null) {
        cancel.textContent = cancelLabel;
    }

    cancel.addEventListener('click', () => hide());

    const handleKeydown = (event) => {
        if (event.key === 'Escape') {
            hide();
        }

        if (event.key === 'Enter' && onConfirm) {
            event.preventDefault();
            onConfirm();
        }
    };

    const drawer = Drawer(dialog, {
        onClose: () => {
            document.removeEventListener('keydown', handleKeydown);
            dialog.remove();
            onClose();
        },
        closeOutside: true,
        animateMask: isMobile(),
    });

    const hide = () => {
        document.removeEventListener('keydown', handleKeydown);
        drawer.close();
    };

    const lock = () => {
        document.removeEventListener('keydown', handleKeydown);
    };

    const render = async () => {
        if (document.querySelector('.mask')) {
            document.querySelector('.mask').click();
        }

        document.body.appendChild(dialog);
        document.addEventListener('keydown', handleKeydown);

        drawer.open();
    };

    return {render, hide, lock, element: dialog};
};
